/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { authAction } from 'shared/store/actions';
import { FormattedMessage } from 'react-intl';
import { isMobileOnly } from 'react-device-detect';
import selectors from 'shared/store/selectors';
import classNames from 'classnames';
import { Button, LanguageSwitcher } from 'components';
import './Navbar.scss';

import Logo from 'assets/icons/logo.png';
import BackButton from 'assets/icons/nextWhite.svg';
import BackButtonBlue from 'assets/icons/icon-back-blue.svg';

const arabicClass = 'arabic';

class Navbar extends Component {
  componentDidMount() {
    const { language } = this.props;
    if (language.locale === 'AR') {
      document.body.classList.add(arabicClass);
    }
  }

  componentWillUnmount() {
    document.body.classList.remove(arabicClass);
  }

  render() {
    const {
      navTitle, rightButton, onRightClick, isRtl, subTitle, className, noTranslate,
      isBlueNav, isTransparentNav, token, onLogout, language,
      match: { url },
    } = this.props;
    // const locale = language?.locale ? language?.locale.toLowerCase() : 'en';
    const navbarClass = classNames({
      navbar: true,
      'navbar--rtl': isRtl,
      'navbar--blue': isMobileOnly && isBlueNav,
      'navbar--transparent': isTransparentNav,
    });
    const leftContent = <span />;
    // const leftContent = leftButton ? <button type="button" onClick={onLeftClick}>{leftButton}</button> : <span />;
    // const leftContent = !isMobileOnly ? (
    //   <section className="desktop-nav">
    //     <img src={Logo} alt="iMarkaz On-Boarding" className="logo" />
    //     <a href={`${process.env.REACT_APP_MAIN_WRAPPER}/#${locale}`} rel="noopener noreferrer">
    //       <FormattedMessage id="navbar.backToIMarkaz" />
    //     </a>
    //   </section>
    // ) : <a className="back-button" href={`${process.env.REACT_APP_MAIN_WRAPPER}/#${locale}`} rel="noopener noreferrer"><img src={url === '/home' ? BackButton : BackButtonBlue} alt="Back to home" /></a>;
    const rightContent = rightButton ? <button type="button" onClick={onRightClick}>{rightButton}</button> : <></>;

    return (
      <header className={`${className} ${navbarClass}`}>
        {leftContent}

        <div className="navbar__title">
          {subTitle && <span className="navbar__subTitle">{subTitle}</span>}
          {navTitle && !noTranslate ? <FormattedMessage id={navTitle} /> : navTitle}
          {/* {navTitle && !noTranslate ? navTitle : navTitle} */}
        </div>
        <nav className="navbar__wrapper">
          <LanguageSwitcher />

          {!isMobileOnly && token && (
          <>
            <NavLink activeClassName="ih-navbar__active" className="nav-link" to="/home" exact>
              <FormattedMessage id="navbar.homepage" />
            </NavLink>

            <Button
              isLink
              value={<FormattedMessage id="navbar.logout" />}
              onButtonClick={() => onLogout()}
            />
          </>
          )}
        </nav>
        {isMobileOnly && token && (
          <span className="logout-mobile" onClick={() => onLogout()}>
            <FormattedMessage id="navbar.logout" />
          </span>
        )}

        {isMobileOnly && rightContent}
      </header>
    );
  }
}

const mapStateToProps = state => ({
  token: selectors.getToken(state),
  language: selectors.getLanguage(state),
});

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(authAction.logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar));
